import omit from 'lodash/omit';

import { merge } from '../../../../utils/state';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';
import entity from './entity';

const coreReducer = entity.getReducer();

const INITIAL_STATE = {
  ...ReduxRestEntity.initialState,
  newOrgId: null,
  newSubOrgId: null,
  isLoading: false,
  searchQuery: '',
  sortOptions: {
    sort_field: 'created_at',
    desc_sort: 'true',
  },
  pagination: {
    pageSize: 15,
    pageNumber: 1,
    hasMore: false,
    totalElements: 0,
  },
  profiles: {
    ...ReduxRestEntity.initialState,
    pagination: {
      pageSize: 15,
      pageNumber: 1,
      hasMore: false,
      totalElements: 0,
    },
  },
};

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case TYPES.CREATE_ORG_REQUEST:
      return merge(state, {
        isLoading: true,
        error: null,
      });
    case TYPES.CREATE_ORG_SUCCESS:
      return merge(state, {
        isLoading: false,
        error: null,
        data: action.payload.response,
        newOrgId: action.payload.newOrgId,
      });
    case TYPES.CREATE_ORG_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload.error,
      });
    case TYPES.CREATE_SUB_ORG_REQUEST:
      return merge(state, {
        isLoading: true,
        newSubOrgId: null,
        error: null,
      });
    case TYPES.CREATE_SUB_ORG_SUCCESS:
      return merge(state, {
        isLoading: false,
        newSubOrgId: action.payload.id,
        error: null,
        data: { ...omit(action.payload, ['id']), ...state.data },
      });
    case TYPES.CREATE_SUB_ORG_FAILURE:
      return merge(state, {
        isLoading: false,
        newSubOrgId: null,
        error: action.payload,
      });
    case TYPES.UPDATE_SUB_ORGS_REQUEST:
      return merge(state, {
        isLoading: true,
        error: null,
      });
    case TYPES.UPDATE_SUB_ORGS_SUCCESS:
      return merge(state, {
        isLoading: false,
        error: null,
        data: { ...state.data, ...action.payload },
      });
    case TYPES.UPDATE_SUB_ORGS_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
      });
    case TYPES.CLEAR_NEW_SUB_ORG_ID:
      return merge(state, {
        newSubOrgId: null,
      });
    case TYPES.GET_SUB_ORGS_REQUEST:
      if (action.payload?.page === 1) {
        return merge(state, { ...INITIAL_STATE, isLoading: true });
      }
      return merge(state, {
        isLoading: true,
      });
    case TYPES.GET_SUB_ORGS_SUCCESS:
      return merge(state, {
        isLoading: false,
        data: merge(state.data, action.payload.content),
        sortOptions: action.payload.sortOptions,
        pagination: merge(state.pagination, {
          pageNumber: action.payload.pagination.number + 1,
          hasMore: !action.payload.pagination.last,
          totalElements: action.payload.pagination.totalElements,
        }),
      });
    case TYPES.GET_SUB_ORGS_FAILURE:
      return merge(state, {
        isLoading: false,
        error: action.payload,
        pagination: merge(state.pagination, {
          totalElements: 0,
        }),
      });
    case TYPES.CLEAR_STATE:
      return INITIAL_STATE;
    case TYPES.UPDATE_SEARCH_QUERY:
      return merge(state, {
        searchQuery: action.payload,
      });
    case TYPES.UPDATE_SORT_OPTIONS:
      return merge(state, {
        sortOptions: action.payload,
      });
    case TYPES.DELETE_SUB_ORG_REQUEST:
      return merge(state, {
        isLoading: true,
      });
    case TYPES.DELETE_SUB_ORG_SUCCESS:
      return merge(state, {
        isLoading: false,
      });
    case TYPES.DELETE_SUB_ORG_ERROR:
      return merge(state, {
        isLoading: false,
        error: action.payload.error,
      });
    case TYPES.GET_PROFILES_BY_ORG_REQUEST:
      if (action.payload?.page === 1) {
        return merge(state, {
          profiles: merge(state.profiles, {
            ...INITIAL_STATE.profiles,
            isLoading: true,
          }),
        });
      }
      return merge(state, {
        profiles: merge(state.profiles, {
          isLoading: true,
        }),
      });
    case TYPES.GET_PROFILES_BY_ORG_SUCCESS:
      return merge(state, {
        profiles: merge(state.profiles, {
          data: merge(state.profiles.data, action.payload.content),
          isLoading: false,
          pagination: merge(state.profiles.pagination, {
            hasMore: !action.payload.pagination.last,
            pageNumber: action.payload.pagination.number + 1,
            totalElements: action.payload.pagination.totalElements,
          }),
        }),
      });
    case TYPES.GET_PROFILES_BY_ORG_ERROR:
      return merge(state, {
        profiles: merge(state.profiles, {
          error: action.payload,
          isLoading: false,
          pagination: merge(state.profiles.pagination, { totalElements: 0 }),
        }),
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
